export default __webpack_public_path__ + "static/proximity-arrow-aa46f6b68381d938912c53bb22f7fbee.png";